module.exports = __webpack_public_path__ + "assets/appStore-86a1d0.svg";